import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BackButtonService } from 'src/app/services/biometrics/back-button.service';
import { BiometricsDataService } from 'src/app/services/biometrics/biometrics-data.service';
import { BiometricsService } from 'src/app/services/biometrics/biometrics.service';
import { GetPresignedUrlService } from 'src/app/services/biometrics/get-presigned-url.service';
import { FILE_TYPE_PARAM } from 'src/app/shared/data/biometrics.constants';
import {
  EBiometricsType,
  ERoute,
  EscreenKeys,
  IBiometricsResults
} from 'src/app/shared/interfaces/biometrics.interface';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { AnalyticService } from 'src/app/shared/services/analytic.service';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';

@Component({
  selector: 'app-biometrics-result',
  templateUrl: './biometrics-result.component.html',
  styleUrls: ['./biometrics-result.component.scss']
})
export class BiometricsResultComponent implements OnInit, OnDestroy {
  image: string = '';
  results_texts: IBiometricsResults;
  type: EBiometricsType;
  screenKey = EscreenKeys.RESULT;
  route: ERoute.WEB | ERoute.MOBILE;
  isVertical: boolean = false;
  private subscriptions = new Subscription();
  constructor(
    private backButtonService: BackButtonService,
    private biometricsDataService: BiometricsDataService,
    private biometricsService: BiometricsService,
    private getPresignedUrlService: GetPresignedUrlService,
    private customerDataService: CustomerDataService,
    private activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticService,
    private router: Router
  ) {
    this.route = this.biometricsService.isMobile ? ERoute.MOBILE : ERoute.WEB;
    this.type = this.activatedRoute.snapshot.paramMap.get(
      FILE_TYPE_PARAM
    ) as EBiometricsType;
    this.results_texts =
      this.biometricsDataService.biometricsResults[this.type];
  }

  ngOnInit() {
    this.getImage();
    this.getSize();
    this.backButtonService.checkScreen(this.type, this.screenKey);
  }

  getSize() {
    this.isVertical = window.innerWidth < window.innerHeight;
  }

  getImage(): void {
    this.image =
      'data:image/jpeg;base64,' +
      this.biometricsDataService.resultsFromBiometrics[this.type]?.Image;
  }

  goRepeat() {
    this.router.navigate([
      this.biometricsDataService.routingBiometrics[this.type][this.screenKey]
        .retake
    ]);
  }

  saveImage(): void {
    let sub = this.getPresignedUrlService
      .uploadImage(
        this.biometricsDataService.resultsFromBiometrics[this.type]?.Image ??
          '',
        this.biometricsDataService.presignedUrls[this.type],
        `${this.customerDataService.customerData.documentType}_${
          this.customerDataService.customerData.numberDNI
        }${this.biometricsDataService.generalData[this.type].filename}`
      )
      .subscribe(
        (r) => {
          if (r.status === 200) {
            this.router.navigate([
              this.biometricsDataService.routingBiometrics[this.type][
                this.screenKey
              ].to
            ]);
            return;
          }
          this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
        },
        (error) => {
          const errorMessage = error.message ?? '';
          this.analyticsService.uTagLinkError(
            'Error servicio presigned url file ' + errorMessage,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
        }
      );
    this.subscriptions.add(sub);
  }

  goBack() {
    this.router.navigate([this.backButtonService.backButton$.value.to]);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
